import { render, staticRenderFns } from "./theme_menu.vue?vue&type=template&id=1844f7f2&scoped=true"
import script from "./theme_menu.vue?vue&type=script&lang=js"
export * from "./theme_menu.vue?vue&type=script&lang=js"
import style0 from "./theme_menu.vue?vue&type=style&index=0&id=1844f7f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1844f7f2",
  null
  
)

export default component.exports